import React from 'react';

import { getTranslateFunc } from '../../../../utils/stringUtil';
import IbButton from '../../../../components/common/IbButton';
import IbTypography from '../../../../components/common/IbTypography';
import IbConfirmModal from '../../../../components/common/IbConfirmModal';
import { DataInterfaceType } from '../../../../../gamma-api';

interface IDisableAgentProps {
  interfaceType: DataInterfaceType;
  visible: boolean;
  loading?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const DisableAgent: React.FC<IDisableAgentProps> = ({ interfaceType, visible, loading, onConfirm, onCancel }) => {
  const translatePrefix = interfaceType === DataInterfaceType.Api ? 'API' : 'Chat';
  const translate = getTranslateFunc(`Agent: ${translatePrefix}: Confirm: Disable:`);

  return (
    <IbConfirmModal
      footer={
        <>
          <IbButton key="disable-confirm" status="error" onClick={onConfirm}>
            {translate('Confirm')}
          </IbButton>
          <IbButton key="disable-cancel" type="secondary" onClick={onCancel}>
            {translate('Cancel')}
          </IbButton>
        </>
      }
      loading={loading}
      title={translate('Title')}
      visible={visible}
      onCancel={onCancel}
    >
      <IbTypography.Paragraph type="secondary">{translate('Content')}</IbTypography.Paragraph>
    </IbConfirmModal>
  );
};

export default DisableAgent;
